var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseButton = function SvgCloseButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    fillRule: "evenodd",
    d: "M.68 2.894 2.894.68l9.592 9.592L22.108.68l2.214 2.214-9.622 9.592 9.622 9.622-2.214 2.214-9.622-9.622-9.592 9.622L.68 22.108l9.592-9.622z",
    clipRule: "evenodd"
  })));
};
export { SvgCloseButton as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjY3OTY4OCAyLjg5MzU2TDIuODkzNTYgMC42Nzk2ODhMMTIuNDg2MyAxMC4yNzI0TDIyLjEwODMgMC42Nzk2ODhMMjQuMzIyMiAyLjg5MzU2TDE0LjcwMDIgMTIuNDg2M0wyNC4zMjIyIDIyLjEwODNMMjIuMTA4MyAyNC4zMjIyTDEyLjQ4NjMgMTQuNzAwMkwyLjg5MzU2IDI0LjMyMjJMMC42Nzk2ODggMjIuMTA4M0wxMC4yNzI0IDEyLjQ4NjNMMC42Nzk2ODggMi44OTM1NloiIGZpbGw9IiMxNzE3MTciLz4KPC9zdmc+Cg==";